import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';

const defaultPillar = {
  id: null,
  name: null,
  weightOld: null,
  weightNew: null,
  weightNewComing: null,
  createdDate: null,
};

const INITIAL_STATE = fromJS({
  pillar: fromJS(defaultPillar),
  fetching: false,
  posting: false,
  updating: false,
  deleting: false
});

function createPillar(state, action) {
  return state
    .set('posting', true)
}

function createPillarSuccess(state, action) {
  return state
    .set('posting', false)
    .set('message', 'Pillar was created successfully')
}

function createPillarFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to create pillar'
  }
  return state
    .set('posting', false)
    .set('message', msg)
}

function getPillarById(state, action) {
  return state
    .set('fetching', true)
}

function getPillarByIdSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('pillar', fromJS(action.payload.body))
}

function getPillarByIdFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to load pillar'
  }
  return state
    .set('fetching', false)
    .set('message', msg)
}

function updatePillar(state, action) {
  return state
    .set('updating', true)
}

function updatePillarSuccess(state, action) {
  return state
    .set('updating', false)
}

function updatePillarFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to update pillar'
  }
  return state
    .set('updating', false)
    .set('message', msg)
}

function changePillarState(state, action) {
  return state
    .set(action.payload.key, action.payload.value)
}

function resetState(state, action) {
  return INITIAL_STATE;
}

function deletePillar(state, action) {
  return state
    .set('deleting', true)
}

function deletePillarSuccess(state, action) {
  return state
    .set('deleting', false)
}

function deletePillarFailed(state, action) {
  return state
    .set('deleting', false)
}

export const pillar = createReducer(INITIAL_STATE, {
  [ActionTypes.CREATE_PILLAR]: createPillar,
  [ActionTypes.CREATE_PILLAR_SUCCESS]: createPillarSuccess,
  [ActionTypes.CREATE_PILLAR_FAILED]: createPillarFailed,
  [ActionTypes.GET_PILLAR_BY_ID]: getPillarById,
  [ActionTypes.GET_PILLAR_BY_ID_SUCCESS]: getPillarByIdSuccess,
  [ActionTypes.GET_PILLAR_BY_ID_FAILED]: getPillarByIdFailed,
  [ActionTypes.UPDATE_PILLAR]: updatePillar,
  [ActionTypes.UPDATE_PILLAR_SUCCESS]: updatePillarSuccess,
  [ActionTypes.UPDATE_PILLAR_FAILED]: updatePillarFailed,
  '@@router/LOCATION_CHANGE': resetState,
  [ActionTypes.CHANGE_PILLAR_STATE]: changePillarState,
  [ActionTypes.DELETE_PILLAR]: deletePillar,
  [ActionTypes.DELETE_PILLAR_SUCCESS]: deletePillarSuccess,
  [ActionTypes.DELETE_PILLAR_FAILED]: deletePillarFailed,
});



// WEBPACK FOOTER //
// ./src/reducers/pillar.js